import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const VIEWER_CREDENTIALS = [
    { username: "impact@gmail.com", password: "impact@2026" },
    { username: "viewer@gmail.com", password: "empower@2026" },
];

export default function ViewerLoginPage() {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("viewer_token") === "authenticated") {
            navigate("/home", { replace: true });
        }
    }, [navigate]);

    const handleLogin = (e) => {
        e.preventDefault();
        setError(false);
        const valid = VIEWER_CREDENTIALS.some(
            (c) => c.username === username.trim() && c.password === password
        );
        if (valid) {
            localStorage.setItem("viewer_token", "authenticated");
            navigate("/home", { replace: true });
        } else {
            setError(true);
        }
    };

    return (
        <div style={S.root}>
            <div style={S.center}>
                <div style={S.card}>
                    <div style={S.cardHeader}>
                        <img
                            src="https://erp.empowerplus.in/files/ep%20logo.png"
                            alt="logo"
                            style={S.cardLogo}
                        />
                        <div style={S.cardTitle}>Impact Dashboard Access</div>
                        <div style={S.cardSub}>Sign in to view impact reports</div>
                    </div>

                    <form onSubmit={handleLogin} style={S.form}>
                        <div style={S.fieldWrap}>
                            <label style={S.label}>Email</label>
                            <input
                                type="email"
                                value={username}
                                onChange={(e) => { setUsername(e.target.value); setError(false); }}
                                placeholder="Enter your email"
                                required
                                style={S.input}
                                autoComplete="email"
                            />
                        </div>

                        <div style={S.fieldWrap}>
                            <label style={S.label}>Password</label>
                            <div style={{ position: "relative" }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => { setPassword(e.target.value); setError(false); }}
                                    placeholder="Enter your password"
                                    required
                                    style={{ ...S.input, paddingRight: 44 }}
                                    autoComplete="current-password"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(v => !v)}
                                    style={S.eyeBtn}
                                    tabIndex={-1}
                                >
                                    {showPassword ? "🙈" : "👁"}
                                </button>
                            </div>
                        </div>

                        {error && (
                            <div style={S.errorBox}>
                                Invalid username or password. Please try again.
                            </div>
                        )}

                        <button type="submit" style={S.submitBtn}>
                            Access Dashboard →
                        </button>
                    </form>
                </div>
            </div>


            <style>{`
                @keyframes vl-fadein {
                    from { opacity: 0; transform: translateY(18px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                .vl-submit:hover {
                    background: linear-gradient(135deg,#1d4ed8,#6d28d9) !important;
                    transform: translateY(-1px) !important;
                    box-shadow: 0 8px 24px rgba(37,99,235,0.45) !important;
                }
                .vl-input:focus {
                    outline: none !important;
                    border-color: #2563eb !important;
                    box-shadow: 0 0 0 3px rgba(37,99,235,0.12) !important;
                }
            `}</style>
        </div>
    );
}

const S = {
    root: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 60%, #1e40af 100%)",
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
        padding: 20,
    },
    center: {
        width: "100%",
        maxWidth: 440,
    },
    card: {
        background: "#fff",
        borderRadius: 20,
        padding: "36px 32px",
        width: "100%",
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
        border: "1px solid #e5e7eb",
        animation: "vl-fadein 0.35s ease",
    },
    cardHeader: { textAlign: "center", marginBottom: 28 },
    cardLogo: { height: 44, marginBottom: 14 },
    cardTitle: { fontSize: 22, fontWeight: 900, color: "#0f172a", letterSpacing: -0.3 },
    cardSub: { fontSize: 13, color: "#6b7280", marginTop: 5 },
    form: { display: "flex", flexDirection: "column", gap: 18 },
    fieldWrap: { display: "flex", flexDirection: "column", gap: 6 },
    label: { fontSize: 12, fontWeight: 700, color: "#374151", textTransform: "uppercase", letterSpacing: 0.5 },
    input: {
        padding: "11px 14px",
        border: "1.5px solid #e5e7eb",
        borderRadius: 10,
        fontSize: 14,
        color: "#0f172a",
        width: "100%",
        boxSizing: "border-box",
        transition: "border-color 0.2s, box-shadow 0.2s",
        background: "#fafafa",
        className: "vl-input",
    },
    eyeBtn: {
        position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
        background: "none", border: "none", cursor: "pointer", fontSize: 16, padding: 2,
        color: "#9ca3af",
    },
    errorBox: {
        background: "#fef2f2",
        color: "#991b1b",
        padding: "10px 14px",
        borderRadius: 10,
        fontSize: 13,
        fontWeight: 600,
        border: "1px solid #fecaca",
    },
    submitBtn: {
        background: "linear-gradient(135deg, #1e3a8a, #2563eb)",
        color: "#fff",
        border: "none",
        padding: "13px 20px",
        borderRadius: 12,
        fontSize: 14,
        fontWeight: 800,
        cursor: "pointer",
        transition: "all 0.2s",
        boxShadow: "0 4px 14px rgba(37,99,235,0.3)",
        marginTop: 4,
        className: "vl-submit",
    },
};
